export function artifactDocumentId(block) {
  const explicitId = String(block?.document_id || '').trim()
  if (explicitId) return explicitId
  const artifactId = String(block?.artifact_id || '')
  return artifactId.startsWith('document:') ? artifactId.slice('document:'.length) : null
}

const STATUS = {
  completed: { label: 'Ready', color: 'var(--app-success, #107c10)', background: 'rgba(16,124,16,.12)' },
  failed: { label: 'Preparation failed', color: 'var(--app-error, #d13438)', background: 'rgba(209,52,56,.12)' },
  processing: { label: 'Preparing', color: 'var(--app-primary, #0078d4)', background: 'rgba(0,120,212,.12)' },
  uploaded: { label: 'Saved', color: 'var(--app-text-secondary)', background: 'var(--app-bg-hover)' },
}

export function artifactCardStatus(documentId, document) {
  if (!documentId) return STATUS.completed
  return STATUS[document?.status] ?? STATUS.uploaded
}
